export default "__VITE_ASSET__CHYpbxqt__"